export const slider = {
  infinite: false,
  speed: 350,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};